import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { isPrestataireLibreRole } from '../../utils/roleUtils';

/**
 * Garde de route pour les pages "commandes" (reservees aux prestataires SOUS CONTRAT
 * et aux acheteurs).
 *
 * Un prestataire libre / libre admin n'a pas d'accord-cadre, donc aucune commande :
 * l'API repond 403 sur ces routes. Plutot que de laisser la page se monter, declencher
 * le fetch, prendre le 403 et se faire ejecter par l'intercepteur global
 * (fetchInterceptor : 403 -> /acces-refuse), on renvoie le libre a son espace (/profil)
 * AVANT tout montage. Le menu masque deja l'entree Commandes pour ces roles.
 */
const RequireContractPrestataire = () => {
  const { user } = useAuth();

  if (user?.role && isPrestataireLibreRole(user.role)) {
    return <Navigate to="/profil" replace />;
  }

  return <Outlet />;
};

export default RequireContractPrestataire;
